<script>
import catalog from '@/mixins/catalog';

export default {

  name: 'popup-product',
  props: ['item'],  
  mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        settings:{}
      }
  },    
  methods: {

    closeFancy : function(){

        $.fancybox.close();
    }


  }

}



</script>

<template>
    <div class="window">
        <div id="card_block">
            <div class="card-add-product" v-if="item.NAME">
                    <div class="img-left">
                        <div class="offer" v-if="item.OFFERS" v-for="OFFER in item.OFFERS">
                                <div class="item-promo-popular-peop" v-if="OFFER.VALUE=='1233'"></div> 
                                <div class="item-promo-akcii"  v-if="OFFER.VALUE=='1231'"></div> 
                                <div class="item-promo-new"  v-if="OFFER.VALUE=='1230'"></div>
                                <div class="item-promo-xit"  v-if="OFFER.VALUE=='1232'"></div>
                                <div class="item-promo-rent-i"  v-if="OFFER.VALUE=='1234'"></div>
                            </div>
                            <img v-if="item.GALLERY.LARGE" :src="item.GALLERY.LARGE[0].src" alt="">
                            <img v-else :src="item.GALLERY[0].src" alt="">
                    </div>
                    <div class="data-right">
                        <div class="stars" >
                                                <div class="star" v-for="star in 5" :class="{active: getRating(star, item)}"></div>
                                                <div class="count-feed">({{getCountFeed(item)}})</div>
                                            </div>
                        <div class="shop-name-container">
                                            <a :href="item.DETAIL_PAGE_URL" class="shop-name">
                                                {{item.NAME}}
                                            </a>
                        </div> 
                        <div class="pos-pr-rel">
                                            <div class="price-list" v-html="item.FORMAT_PRICE">
                                            
                                            </div> 
                                            <div class="old-price-block" v-if="item.PRICE_OLD > 0">
                                                <del class="dis-pr-f" v-html="item.FORMAT_PRICE_OLD"></del>  
                                                <div class="dis-pr hide">-{{item.DISCOUNT_PR}}%</div>
                                            </div> 
                                        </div>
                    </div>
                    <div class="buttons">
                        <a href="/" @click.stop.prevent="closeFancy()" class="feed-back-call-b next-buy">Продолжить покупки</a>
                        <a href="/personal/cart/" class="feed-back-call-b go-basket">В корзину</a>
                    </div>
            </div>
        </div>
    </div>
</template>